import { useFilteredData } from '@ts-core/hooks/ui';

export default function useCourseStudentsTable({
  students: allStudents = [],
  loading,
  onRemoveStudent,
  onSelectStudent,
}) {
  const {
    filteredData: students,
    onFilterData: onFilterStudents,
  } = useFilteredData({
    list: allStudents,
    fields: ['name', 'email', 'personalId'],
  });

  return {
    students,
    loading,
    onFilterStudents,
    onRemoveStudent,
    onSelectStudent,
  };
}
